import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const InsertTrimming = createAsyncThunk('InsertTrimming', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertTrimmingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const TrimmingInwardEntry = createAsyncThunk('TrimmingInwardEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertTrimmingInwardEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchKajeInwMemo = createAsyncThunk('fetchKajeInwMemo', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getKajeInwMemoforTrimming&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTrimmingEmplist = createAsyncThunk('fetchTrimmingEmplist', async (id) => {
    try {
        const endpoint = id ? `getTrimmingEmployee&empId=${id}` : 'getTrimmingEmployee';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTrimmingMemo = createAsyncThunk('fetchTrimmingMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getTrimmingMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTrimmingReg = createAsyncThunk('fetchTrimmingReg', async (id) => {
    try {
        const endpoint = id ? `getTrimmingReg&trId=${id}` : 'getTrimmingReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTrimInwReg = createAsyncThunk('fetchTrimInwReg', async (id) => {
    try {
        const endpoint = id ? `getTrimmingInwardReg&trnId=${id}` : 'getTrimmingInwardReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

// export const fetchKajeReturnReg = createAsyncThunk('fetchKajeReturnReg', async (id) => {
//     try {
//         const endpoint = id ? `getKajeReturnRegister&kinwId=${id}` : 'getKajeReturnRegister';
//         const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });

const trmmingApiSlice = createSlice({
    name: 'TrimmingDatalist',
    initialState: {
        isLoading: false,
        kjInwMemo: null,
        emplist: null,
        trMemo: null,
        trdata: null,
        trInwlist: null,
        relist: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchKajeInwMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeInwMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.kjInwMemo = action.payload;
        });
        builder.addCase(fetchKajeInwMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchTrimmingEmplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTrimmingEmplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.emplist = action.payload;
        });
        builder.addCase(fetchTrimmingEmplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchTrimmingMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTrimmingMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.trMemo = action.payload;
        });
        builder.addCase(fetchTrimmingMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchTrimmingReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTrimmingReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.trdata = action.payload;
        });
        builder.addCase(fetchTrimmingReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchTrimInwReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTrimInwReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.trInwlist = action.payload;
        });
        builder.addCase(fetchTrimInwReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        // builder.addCase(fetchKajeReturnReg.pending, (state, action) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(fetchKajeReturnReg.fulfilled, (state, action) => {
        //     state.isLoading = false;
        //     state.relist = action.payload;
        // });
        // builder.addCase(fetchKajeReturnReg.rejected, (state, action) => {
        //     console.log('Error', action.error.message);
        //     state.isError = true;
        // });

    }
});

export default trmmingApiSlice.reducer;
